/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Environment } from "./Environment";
import { Pagination } from "../../commons/types/Pagination";
export const ListEnvironmentsResponse = core.serialization.object({
    data: core.serialization.list(Environment),
    pagination: Pagination.optional(),
});
